import ClipboardJS from 'clipboard';
import Tooltip  from 'bootstrap/js/dist/tooltip';

export default class extends window.Controller {

    static get targets() {
        return ["billLink"]
    }

    connect() {
        const btn = this.element.children[1];

        btn.dataset.clipboardText = `${this.billLinkTarget.value}`;

        this.clipboard = new ClipboardJS(btn);

        new Tooltip(btn, {
            placement: 'bottom',
            title: 'Скопировано',
            trigger: 'manual',
        });

        btn.onmouseleave = () => {
            const tooltip = Tooltip.getInstance(btn);
            tooltip.hide();
        };
    }

    copy() {
        this.clipboard.on('success', function (e) {
            const tooltip = Tooltip.getInstance(e.trigger);
            tooltip.show();

            e.clearSelection();
        });
    }
}
